import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col" }
const _hoisted_3 = { class: "optional-btn-label" }
const _hoisted_4 = { class: "col" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col" }
const _hoisted_7 = { class: "optional-btn-label" }
const _hoisted_8 = { class: "col" }
const _hoisted_9 = { class: "optional-btn-label" }
const _hoisted_10 = { class: "col" }
const _hoisted_11 = { class: "optional-btn-label" }
const _hoisted_12 = { class: "col" }
const _hoisted_13 = { class: "optional-btn-label" }
const _hoisted_14 = { class: "col" }
const _hoisted_15 = { class: "optional-btn-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vue_feather = _resolveComponent("vue-feather")!
  const _component_new_turbine_modal = _resolveComponent("new-turbine-modal")!
  const _component_new_customer_modal = _resolveComponent("new-customer-modal")!
  const _component_new_aggregator_modal = _resolveComponent("new-aggregator-modal")!
  const _component_new_turbine_model_modal = _resolveComponent("new-turbine-model-modal")!
  const _component_new_blade_model_modal = _resolveComponent("new-blade-model-modal")!
  const _component_commissioning_report_modal = _resolveComponent("commissioning-report-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _cache[19] || (_cache[19] = _createElementVNode("h1", null, "Commissioning", -1)),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[7] || (_cache[7] = _createElementVNode("h2", null, "Aggregator EOL", -1)),
        _cache[8] || (_cache[8] = _createElementVNode("p", null, "Upload the aggregator name and serial number once system has passed EOL testing", -1)),
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-primary",
          title: "new aggregator",
          style: {"margin":"1em"},
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openNewAggregatorModal && _ctx.openNewAggregatorModal(...args)))
        }, [
          _createElementVNode("span", _hoisted_3, [
            _createVNode(_component_vue_feather, {
              type: "plus-square",
              size: "16"
            }),
            _cache[6] || (_cache[6] = _createTextVNode(" Add new Aggregator ", -1))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _cache[13] || (_cache[13] = _createElementVNode("h2", null, "New turbine", -1)),
        _cache[14] || (_cache[14] = _createElementVNode("p", null, "Create a new instance of a turbine; linking site, asset and hardware info together", -1)),
        _cache[15] || (_cache[15] = _createElementVNode("p", null, "The majority of the time you will only need to use 'Add new turbine'", -1)),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary",
              title: "new turbine",
              style: {"margin":"1em"},
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openNewTurbineModal && _ctx.openNewTurbineModal(...args)))
            }, [
              _createElementVNode("span", _hoisted_7, [
                _createVNode(_component_vue_feather, {
                  type: "plus-square",
                  size: "16"
                }),
                _cache[9] || (_cache[9] = _createTextVNode(" New turbine ", -1))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary",
              title: "new customer",
              style: {"margin":"1em"},
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.openNewCustomerModal && _ctx.openNewCustomerModal(...args)))
            }, [
              _createElementVNode("span", _hoisted_9, [
                _createVNode(_component_vue_feather, {
                  type: "plus-square",
                  size: "16"
                }),
                _cache[10] || (_cache[10] = _createTextVNode(" New customer ", -1))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary",
              title: "new turbine model",
              style: {"margin":"1em"},
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.openNewTurbineModelModal && _ctx.openNewTurbineModelModal(...args)))
            }, [
              _createElementVNode("span", _hoisted_11, [
                _createVNode(_component_vue_feather, {
                  type: "plus-square",
                  size: "16"
                }),
                _cache[11] || (_cache[11] = _createTextVNode(" New turbine model ", -1))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary",
              title: "new blade model",
              style: {"margin":"1em"},
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.openNewBladeModelModal && _ctx.openNewBladeModelModal(...args)))
            }, [
              _createElementVNode("span", _hoisted_13, [
                _createVNode(_component_vue_feather, {
                  type: "plus-square",
                  size: "16"
                }),
                _cache[12] || (_cache[12] = _createTextVNode(" New blade model ", -1))
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _cache[17] || (_cache[17] = _createElementVNode("h2", null, "Commissioning report", -1)),
        _cache[18] || (_cache[18] = _createElementVNode("p", null, "Generate a PDF report of a turbine's sensors and when each came online", -1)),
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-primary",
          title: "commissioning report",
          style: {"margin":"1em"},
          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.openCommissioningReportModal && _ctx.openCommissioningReportModal(...args)))
        }, [
          _createElementVNode("span", _hoisted_15, [
            _createVNode(_component_vue_feather, {
              type: "file-text",
              size: "16"
            }),
            _cache[16] || (_cache[16] = _createTextVNode(" Commissioning report ", -1))
          ])
        ])
      ])
    ]),
    (_ctx.showNewTurbineModal)
      ? (_openBlock(), _createBlock(_component_new_turbine_modal, {
          key: 0,
          onClose: _ctx.closeNewTurbineModal,
          onSave: _ctx.closeNewTurbineModal
        }, null, 8, ["onClose", "onSave"]))
      : _createCommentVNode("", true),
    (_ctx.showNewCustomerModal)
      ? (_openBlock(), _createBlock(_component_new_customer_modal, {
          key: 1,
          onClose: _ctx.closeNewCustomerModal,
          onSave: _ctx.closeNewCustomerModal
        }, null, 8, ["onClose", "onSave"]))
      : _createCommentVNode("", true),
    (_ctx.showNewAggregatorModal)
      ? (_openBlock(), _createBlock(_component_new_aggregator_modal, {
          key: 2,
          onClose: _ctx.closeNewAggregatorModal,
          onSave: _ctx.closeNewAggregatorModal
        }, null, 8, ["onClose", "onSave"]))
      : _createCommentVNode("", true),
    (_ctx.showNewTurbineModelModal)
      ? (_openBlock(), _createBlock(_component_new_turbine_model_modal, {
          key: 3,
          onClose: _ctx.closeNewTurbineModelModal,
          onSave: _ctx.closeNewTurbineModelModal
        }, null, 8, ["onClose", "onSave"]))
      : _createCommentVNode("", true),
    (_ctx.showNewBladeModelModal)
      ? (_openBlock(), _createBlock(_component_new_blade_model_modal, {
          key: 4,
          onClose: _ctx.closeNewBladeModelModal,
          onSave: _ctx.closeNewBladeModelModal
        }, null, 8, ["onClose", "onSave"]))
      : _createCommentVNode("", true),
    (_ctx.showCommissioningReportModal)
      ? (_openBlock(), _createBlock(_component_commissioning_report_modal, {
          key: 5,
          onClose: _ctx.closeCommissioningReportModal,
          onSave: _ctx.closeCommissioningReportModal
        }, null, 8, ["onClose", "onSave"]))
      : _createCommentVNode("", true)
  ]))
}